import { createPortal } from "react-dom";

interface FolderContextMenuProps {
  menu: { id: string; name: string; x: number; y: number };
  onClose: () => void;
  onRename: () => void;
  onArchive: () => void;
}

/**
 * The right-click / kebab context menu for a collection (folder), portaled to
 * document.body at the click coordinates.
 */
export function FolderContextMenu({
  menu,
  onClose,
  onRename,
  onArchive,
}: FolderContextMenuProps) {
  return createPortal(
    <div
      style={{ position: "fixed", inset: 0, zIndex: 10000 }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "fixed",
          top: menu.y,
          left: menu.x,
          transform: "translate(-100%, 0)",
          background: "var(--color-surface, white)",
          borderRadius: 8,
          boxShadow: "var(--popover-shadow, 0 4px 16px rgba(0,0,0,0.15))",
          padding: "4px 0",
          minWidth: 140,
          fontSize: 13,
          fontFamily: "'DM Sans', sans-serif",
        }}
      >
        <button
          onClick={onRename}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            width: "100%",
            padding: "8px 14px",
            border: "none",
            background: "none",
            cursor: "pointer",
            fontSize: 13,
            color: "var(--color-text)",
          }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLButtonElement).style.background =
              "var(--color-surface-hover)";
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLButtonElement).style.background = "none";
          }}
        >
          Rename
        </button>
        <button
          onClick={onArchive}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            width: "100%",
            padding: "8px 14px",
            border: "none",
            background: "none",
            cursor: "pointer",
            fontSize: 13,
            color: "var(--color-danger, #dc2626)",
          }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLButtonElement).style.background =
              "var(--color-surface-hover)";
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLButtonElement).style.background = "none";
          }}
        >
          Archive
        </button>
      </div>
    </div>,
    document.body,
  );
}
